module.exports = __webpack_public_path__ + "static/media/earthIcon.b731294a.gif";